// import { throttle } from "lodash";
// import { useEffect, useState } from "react";

// // Also defined in FDS to be used in CSS as var(--mobile-max-width)
// const MOBILE_MAX_WIDTH = 744;

// const isMobileViewPort = () => {
//   // https://stackoverflow.com/questions/1248081/how-to-get-the-browser-viewport-dimensions
//   const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
//   // const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
//   return vw < MOBILE_MAX_WIDTH;
// };

export const useIsMobile = () => {
  // const [isMobile, setIsMobile] = useState(false);
  //
  // useEffect(() => {
  //   // The time on the throttle may need to be adjusted.
  //   const handleResize = throttle(() => {
  //     setIsMobile(isMobileViewPort());
  //   }, 50);
  //
  //   window.addEventListener("resize", handleResize);
  //   handleResize();
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  // NOTE: we are disabling mobile for now
  return false;
};
